/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignListMessageDialog extends NoboxEntityDialog<CampaignTagsRow, any> {
        protected getFormKey() { return CampaignListMessageForm.formKey; }

        protected form = new CampaignListMessageForm(this.idPrefix);
        private totalMenu = 0;
        private listMenu = [];
        private listSubMenu = [];
        private resArrMenu = [];
        private newMenuNo = null;
        public saveCallback: (response: string) => void;

        constructor() {
            super();
            this.form.ListEl.element.find(".el-list").html(``);
        }

        addMenu(text: string) {
            this.newMenuNo = this.totalMenu;
            var id = this.newMenuNo;
            this.listMenu.push({
                id: this.totalMenu,
                text: text
            });
            this.resArrMenu.push({
                title: text,
                rows: [
                ]
            });
            var el = $(`<div class="accordion-item accordion-${this.totalMenu}">
                        <div class="accordion-head" data-toggle="collapse">
                            <h6 class="title"><span class="label-menu">${text}</span>
                                <div class="btn btn-menu-edit"><i class="fa fa-edit text-primary"></i></div>
                                <div class="btn btn-menu-remove"><i class="fa fa-close text-red"></i></div>
                            </h6>
                        </div>
                        <div class="accordion-body collapse show pt-0">
                            <div class="accordion-inner pt-0">
                                <ul class="nk-activity">

                                </ul>
                            </div>
                        </div>
                    </div>`);
            el.find(".btn-menu-remove").on("click", () => {
                this.removeMenu(id, el)
            });

            el.find(".btn-menu-edit").on("click", () => {
                var dlg = new CampaignListMenuDialog({ IsEdit: true, Section: el.find(".label-menu").text() });
                dlg.editCallback = (title) => {
                    el.find(".label-menu").text(title);
                    this.listMenu[id].text = title;
                    this.resArrMenu[id].title = title;
                };
                dlg.loadNewAndOpenDialog();
            });

            this.totalMenu++;
            this.form.ListEl.element.find(".el-list").append(el);
        }

        addMenuInbox(text: string) {
            this.newMenuNo = this.totalMenu;
            var id = this.newMenuNo;
            this.listMenu.push({
                id: this.totalMenu,
                text: text
            });
            this.resArrMenu.push({
                title: text,
                rows: [
                ]
            });
            var el = $(`<div class="accordion-item accordion-${this.totalMenu}">
                        <div class="accordion-head" data-toggle="collapse">
                            <h6 class="title"><span class="label-menu">${text}</span></h6>
                        </div>
                        <div class="accordion-body collapse show pt-0">
                            <div class="accordion-inner pt-0">
                                <ul class="nk-activity">

                                </ul>
                            </div>
                        </div>
                    </div>`);

            this.totalMenu++;
            this.form.ListEl.element.find(".el-list").append(el);
        }

        removeMenu(noMenu, el: JQuery) {
            Q.confirm("Are you sure to delete this menu?", () => {
                this.resArrMenu.splice(noMenu, 1);
                var iniArr = this.resArrMenu;
                this.totalMenu = 0;
                this.listMenu = [];
                this.listSubMenu = [];
                this.resArrMenu = [];
                this.newMenuNo = null;
                this.form.ListEl.element.find(".el-list").html("");
                iniArr.forEach((x, i) => {
                    this.addMenu(x.title);
                    x.rows.forEach((sub, isub) => {
                        this.addSubMenu(i, sub.title, sub.description || "")
                    })
                })
            });
        }

        removeSubMenu(noMenu, noSubMenu, el: JQuery) {
            Q.confirm("Are you sure to delete this sub menu?", () => {
                el.remove()
                this.listSubMenu = this.listSubMenu.filter(item => { return (item.Id != noSubMenu && item.NoMenu != noMenu) });
                this.resArrMenu[noMenu].rows = this.resArrMenu[noMenu].rows.filter(item => { return (item.rowId != `option${noSubMenu}`) });
            });
        }

        addSubMenu(noMenu: number, title: string, desc: string) {
            var noSubMenu = this.listSubMenu.length;
            this.listSubMenu.push({
                NoMenu: noMenu,
                Id: noSubMenu,
                Title: title,
                Desc: desc
            });
            var el = $(`<li class="nk-activity-item ml-0" data-menu="${noMenu}" data-sub="${noSubMenu}">
                            <div class="nk-activity-data">
                                <div class="label">${title}</div>
                                <span class="time">${desc}</span>
                            </div>
                            <div class="nk-activity-action">
                                <div class="btn btn-submenu-edit"><i class="fa fa-edit text-primary"></i></div>
                                <div class="btn btn-submenu-remove"><i class="fa fa-close text-red"></i></div>
                            </div>
                        </li>`);
            el.find(".btn-submenu-remove").on("click", () => {
                this.removeSubMenu(noMenu, noSubMenu, el)
            });

            el.find(".btn-submenu-edit").on("click", () => {
                var dlg = new CampaignListSubMenuDialog({ Title: el.find(".nk-activity-data .label").text(), Desc: el.find(".nk-activity-data .time").text(), IsEdit: true, NoMenu: noMenu });
                dlg.setLookup(this.listMenu);
                dlg.editCallback = (noSection, title, desc) => {
                    el.find(".nk-activity-data .label").text(title);
                    el.find(".nk-activity-data .time").text(desc);

                    var IndexlistSubMenu = this.listSubMenu.findIndex(x => x.Id == noSubMenu && x.NoMenu == noMenu);
                    this.listSubMenu[IndexlistSubMenu].Title = title;
                    this.listSubMenu[IndexlistSubMenu].Desc = desc;

                    var IndexresArrMenu = this.resArrMenu[noMenu].rows.findIndex(x => x.rowId == `option${noSubMenu}`);
                    this.resArrMenu[noMenu].rows[IndexresArrMenu].title = title;
                    this.resArrMenu[noMenu].rows[IndexresArrMenu].description = desc;
                };
                dlg.loadNewAndOpenDialog();
            });

            if (Q.isEmptyOrNull(desc)) {
                this.resArrMenu[noMenu].rows.push({
                    title: title,
                    rowId: `option${noSubMenu}`,
                })
            } else {
                this.resArrMenu[noMenu].rows.push({
                    title: title,
                    rowId: `option${noSubMenu}`,
                    description: desc
                })
            }
            this.form.ListEl.element.find(".el-list").first().find(`.accordion-item.accordion-${noMenu} .accordion-body .accordion-inner ul`).append(el);
        }

        addSubMenuInbox(noMenu: number, title: string, desc: string) {
            var noSubMenu = this.listSubMenu.length;
            this.listSubMenu.push({
                NoMenu: noMenu,
                Id: noSubMenu,
                Title: title,
                Desc: desc
            });
            var el = $(`<li class="nk-activity-item ml-0" data-menu="${noMenu}" data-sub="${noSubMenu}">
                            <div class="nk-activity-data">
                                <div class="label">${title}</div>
                                <span class="time">${desc}</span>
                            </div>
                        </li>`);

            if (Q.isEmptyOrNull(desc)) {
                this.resArrMenu[noMenu].rows.push({
                    title: title,
                    rowId: `option${noSubMenu}`,
                })
            } else {
                this.resArrMenu[noMenu].rows.push({
                    title: title,
                    rowId: `option${noSubMenu}`,
                    description: desc
                })
            }
            this.form.ListEl.element.find(".el-list").first().find(`.accordion-item.accordion-${noMenu} .accordion-body .accordion-inner ul`).append(el);
        }

        getToolbarButtons() {
            var buttons = [];
            buttons.push({
                title: "Add Menu",
                cssClass:"btn-addMenu",
                onClick: () => {
                    if (this.newMenuNo != null) {
                        if (this.resArrMenu[this.newMenuNo].rows.length != 0) {
                            var dlg = new CampaignListMenuDialog({});
                            dlg.saveCallback = (section) => {
                                this.addMenu(section)
                            };
                            dlg.loadNewAndOpenDialog();
                        } else {
                            Q.notifyError(`Please Add Sub Menu of Menu ${this.resArrMenu[this.newMenuNo].title} first`)
                        }
                    } else {
                        var dlg = new CampaignListMenuDialog({});
                        dlg.saveCallback = (section) => {
                            this.addMenu(section)
                        };
                        dlg.loadNewAndOpenDialog();
                    }
                }
            });
            buttons.push({
                title: "Add Sub Menu",
                cssClass: "btn-addSubMenu",
                separator:true,
                onClick: () => {
                    if (this.newMenuNo != null) {
                        var dlg = new CampaignListSubMenuDialog({});
                        dlg.setLookup(this.listMenu);
                        dlg.saveCallback = (noSection, title, desc) => {
                            this.addSubMenu(noSection, title, desc);
                        };
                        dlg.loadNewAndOpenDialog();
                    } else {
                        Q.notifyError(`Please Add Menu first`)
                    }
                }
            });
            return buttons;
        }

        setEditMode(arr: string) {
            var list = JSON.parse(arr);
            list.forEach((x, i) => {
                this.addMenu(x.title);
                x.rows.forEach((sub, isub) => {
                    this.addSubMenu(i, sub.title, sub.description||"")
                })
            })
        }

        showFromInbox(arr: string) {
            var list = JSON.parse(arr);
            list.forEach((x, i) => {
                this.addMenuInbox(x.title);
                x.rows.forEach((sub, isub) => {
                    this.addSubMenuInbox(i, sub.title, sub.description || "")
                })
            })
        }

        hideFromInbox() {
            $(".btn-addMenu").hide();
            $(".btn-addSubMenu").hide();
            $(".btn-saveListMessage").hide();
        }

        getDialogButtons() {
            var buttons = [] as Serenity.DialogButton[];
            buttons.push({
                text: "Save",
                click: () => {
                    if (this.newMenuNo == null) {
                        Q.notifyError(`Please Add Menu and Sub Menu first to save this list`)
                    } else if (this.resArrMenu[this.newMenuNo].rows.length == 0) {
                        Q.notifyError(`Please Add Sub Menu of Menu ${this.resArrMenu[this.newMenuNo].title} first to save this list`)
                    } else {
                        this.saveCallback(JSON.stringify(this.resArrMenu));
                        this.dialogClose();
                    }
                },
                cssClass: "btn-saveListMessage"
            });
            return buttons;
        }

        updateTitle() {
            this.dialogTitle = "List Message";
        }
    }
}